/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/signature';
import '../common/tipping';
import '../common/customer_management';
import '../common/order_tickets';
import '../common/payment_sounds';
import '../common/payment_types';
import '../common/security';
import '../common/quick_amounts';
import '../common/store_and_forward';
import '../common/scan_to_pay';
import '../common/buyer_facing_display';
import '../common/fulfillment_types';
import './common/seating';
import './common/course_management';
import './common/floor_plan';
import './common/appearance';
import './common/order_hub';
import './common/orders_mode';
import './common/text_customer';
import '../common/vpos/checkout';
import '../addons/cash_management';
import '../addons/open_tickets';
import '../addons/gift_cards';
import '../addons/online_checkout';
import '../addons/text_message_marketing';
import '../addons/loyalty';
import '../addons/team_management';
import '../addons/invoices';
import '../addons/staff';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "RSTSettings": {
                                "fields": {
                                  "signature": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "tipping": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "customerManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagement",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "orderTickets": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "paymentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentTypes",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "quickAmounts": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "storeAndForward": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "scanToPay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScanToPay",
                                    "id": 20,
                                    "rule": "optional"
                                  },
                                  "buyerFacingDisplay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.BuyerFacingDisplay",
                                    "id": 21,
                                    "rule": "optional"
                                  },
                                  "fulfillmentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.FulfillmentTypes",
                                    "id": 22,
                                    "rule": "optional"
                                  },
                                  "seating": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.Seating",
                                    "id": 11,
                                    "rule": "optional"
                                  },
                                  "courseManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.CourseManagement",
                                    "id": 12,
                                    "rule": "optional"
                                  },
                                  "floorPlan": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.FloorPlan",
                                    "id": 13,
                                    "rule": "optional"
                                  },
                                  "appearance": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance",
                                    "id": 14,
                                    "rule": "optional"
                                  },
                                  "orderHub": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.OrderHub",
                                    "id": 15,
                                    "rule": "optional"
                                  },
                                  "ordersMode": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.OrdersMode",
                                    "id": 16,
                                    "rule": "optional"
                                  },
                                  "textCustomer": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer",
                                    "id": 19,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.AddonsSettings",
                                    "id": 17,
                                    "rule": "optional"
                                  },
                                  "checkout": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.vpos.Checkout",
                                    "id": 18,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AddonsSettings": {
                                "fields": {
                                  "cashManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.CashManagement",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "openTickets": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OpenTickets",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "giftCards": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.GiftCards",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "onlineCheckout": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OnlineCheckout",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "textMessageMarketing": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "loyalty": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "teamManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TeamManagement",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "invoices": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Invoices",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "staff": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Staff",
                                    "id": 9,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.RSTSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.AddonsSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE RSTSettings @ squareup/devicesettings/profiles/v2/model/settings/rst/rst_settings.proto at 49:1
 */
export const RSTSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.RSTSettings');
fixType(RSTSettings);
Builder.createAndAttachToType(RSTSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/rst/rst_settings.proto at 80:1
 */
export const AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.AddonsSettings');
fixType(AddonsSettings);
Builder.createAndAttachToType(AddonsSettings);